import {Locale, setDefaultOptions} from 'date-fns';
import {de, enUS, es, fr, it, pt} from 'date-fns/locale';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend, {HttpBackendOptions} from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
i18n
  // Enables the i18next backend
  .use(Backend)
  // Enable automatic language detection
  .use(LanguageDetector)
  // Enables the hook initialization module
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    // Standard language used
    fallbackLng: 'en',
    supportedLngs: ['de', 'en', 'es', 'fr', 'it', 'pt'],
    debug: false,
    returnNull: false,
    //Detects and caches a cookie from the language provided
    detection: {
      order: ['querystring', 'cookie', 'navigator'],
      caches: ['cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
    load: 'currentOnly',
  });

const locales: Record<string, Locale> = {de, en: enUS, es, fr, it, pt};
i18n.on('languageChanged', (lng) => {
  console.log('Language changed to: ', lng);
  document.documentElement.setAttribute('lang', lng);
  // Beaucoup plus lisible et extensible
  setDefaultOptions({
    locale: locales[lng] || enUS,
  });
});

export {i18n};
